// extracted by mini-css-extract-plugin
export default {"gif":"v_b3","gif--wrapped":"v_b4"};